import { configureStore } from '@reduxjs/toolkit'
import PolygonReducer from './slices/PolygonSlice'
import SelctedPolygonReducer from './slices/SelectedPolygonSlice'
import EditModeReducer from './slices/EditModeSlice'
import MarkerReducer from './slices/MarkerSlice'
import SasTokenReducer from './slices/SasTokenSlice'
import ViewPositionReducer from './slices/ViewPositionSlice'
import AuthReducer from './slices/AuthSlice'
import PackageReducer from './slices/PackageSlice'
import TorkSettingsReducer from './slices/TorkSettingsSlice'
import DeletedPackageReducer from './slices/DeletedPackageSlice'
import TorkOrderReducer from './slices/TorkOrderSlice'
import TorkReducer from './slices/TorkSlice'
import TorkNoteTypeReducer from './slices/TorkNoteTypeSlice'

export const store = configureStore({
  reducer: {
    polygons: PolygonReducer,
    selectedPolygon: SelctedPolygonReducer,
    editMode: EditModeReducer,
    markers: MarkerReducer,
    sasToken: SasTokenReducer,
    mapPosition: ViewPositionReducer,
    auth: AuthReducer,
    packages: PackageReducer,
    torkSettings: TorkSettingsReducer,
    deletedPackages: DeletedPackageReducer,
    torkOrders: TorkOrderReducer,
    torks: TorkReducer,
    torkNoteTypes: TorkNoteTypeReducer
  }
})